import styled from 'styled-components'
import { Select } from 'antd'

export const SmallTypeSelect = styled(Select)`
	&,
	&.ant-select-single:not(.ant-select-customize-input) {
		width: 136px;

		.ant-select-selector,
		.ant-input {
			height: 42px;
			border: 0;
			border-radius: 0;
		}

		.ant-select-selector {
			padding: 0 16px 0 14px;
			background-color: transparent;

			.ant-select-selection-item {
				font-size: 14px;
				font-weight: 500;
				color: #1b1b29;
				line-height: 42px;
				padding: 0;

				@media (max-width: 768px) {
					font-size: 14px;
				}
			}
		}

		.ant-select-arrow {
			inset-inline-end: 0;

			span {
				&:before {
					display: block;
					content: '';
					width: 0;
					height: 0;
					border-left: 4px solid transparent;
					border-right: 4px solid transparent;
					border-top: 4px solid #1b1b29;
				}

				svg {
					display: none;
				}
			}
		}
	}
`
